const LOCALE_COOKIE = "c_locale";

export { LOCALE_COOKIE };
